import { internalFetch } from '../utils/fetchHelper';
import type {
  OrderBilling,
  FinalizeBilling,
} from '@moko/ui/src/Work/billing/types';
export type {
  OrderBilling,
  FinalizeBilling,
} from '@moko/ui/src/Work/billing/types';
const api = import.meta.env.VITE_BACKEND_API_URL as string;
export const getOrderBilling = (
  controller: AbortController,
  id: number
): Promise<OrderBilling> =>
  internalFetch(`${api}/p/order/${id}/billing`, 'GET', controller);
export const finalizeOrderBilling = (
  controller: AbortController,
  id: number,
  request: FinalizeBilling
): Promise<OrderBilling> =>
  internalFetch(
    `${api}/p/order/${id}/billing/finalize`,
    'POST',
    controller,
    JSON.stringify(request)
  );
